module.exports = __webpack_public_path__ + "img/yyjc1.cb7678b2.png";